import moment from 'moment';

/**
 * Checks if a given date is a weekday (Monday to Friday).
 * @param {string|Date|moment.Moment} date - The date to check. Can be a string, Date object, or moment object.
 * @returns {boolean} - Returns true if the date is a weekday, false if it's Saturday or Sunday.
 */
export function isWeekday(date) {
  const day = moment(date).day();
  return day >= 1 && day <= 5;
}

/**
 * Gets the ISO week number and related information from a given date.
 * @param {string|Date|moment.Moment} date - The date to extract week information from. Can be a string, Date object, or moment object.
 * @returns {Object} - An object containing the ISO week number, year, start date, end date, month, month name, and year of the month.
 */

export function iSOWeekNumbFromDate(date) {
  const momentDate = moment(date);

  const startOfWeek = momentDate.clone().startOf('isoWeek');
  const endOfWeek = momentDate.clone().endOf('isoWeek');
  const week = momentDate.isoWeek();
  const weekWFormated = String(week).padStart(2, '0');

  return {
    week: weekWFormated,
    weekYear: `${momentDate.isoWeekYear()}${weekWFormated}`,
    year: momentDate.isoWeekYear(),
    range: {
      startDate: startOfWeek.format('YYYY-MM-DD'),
      endDate: endOfWeek.format('YYYY-MM-DD'),
      startDateFetchFormat: startOfWeek.format('YYYYMM'),
      endDateFetchFormat: endOfWeek.format('YYYYMM'),
    },
    currentMont: momentDate.month() + 1, // (0-11 → 1-12)
    monthName: momentDate.format('MMMM'),
    yearOfMonth: momentDate.year(),
    yearMonth: momentDate.format('YYYYMM'),
  };
}

/*
  gets the number of ISO weeks in the month of the given date.
  @param {string|Date|moment.Moment} date - The date to get the number of weeks in the month from. Can be a string, Date object, or moment object.
  @returns {number} - The number of ISO weeks in the month of the given date.
**/
export function weeksInMonth(date) {
  const start = moment(date).startOf('month');
  const end = moment(date).endOf('month');

  const startWeek = start.isoWeek();
  const endWeek = end.isoWeek();

  if (endWeek < startWeek) {
    return end.isoWeeksInYear() - startWeek + endWeek + 1;
  }

  return endWeek - startWeek + 1;
}
